module.exports = __webpack_public_path__ + "assets/pin-green.942dc259cb935a01795a2c882513bbf4.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/pin/pin-green.png
// module id = 517
// module chunks = 0